"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("./constants");
var ApplicationInformation = function ApplicationInformation(_ref) {
  var showEmploymentInfo = _ref.showEmploymentInfo,
    applicantName = _ref.applicantName,
    employerTooltip = _ref.employerTooltip,
    errors = _ref.errors,
    register = _ref.register;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h3", {
    className: "applicant-info-header"
  }, "Applicant Information:"), /*#__PURE__*/_react.default.createElement("h5", {
    className: "applicant-info-subheader"
  }, "The information provided here will not impact the offer you've already selected."), /*#__PURE__*/_react.default.createElement("div", {
    className: "applicant-info"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "applicant-info-labels"
  }, /*#__PURE__*/_react.default.createElement("label", {
    "data-test-id": "name-label",
    className: "applicant-info-label applicant-name-lable"
  }, "Applicant name:"), /*#__PURE__*/_react.default.createElement("label", {
    className: "applicant-info-label applicant-employment-status-label"
  }, "Employment Status:"), showEmploymentInfo && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("label", {
    className: "applicant-info-label applicant-employer-label"
  }, "Employer:"), /*#__PURE__*/_react.default.createElement("label", {
    className: "applicant-info-label applicant-job-title-label"
  }, "Job title:"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "applicant-info-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "applicant-info-data applicant-name"
  }, /*#__PURE__*/_react.default.createElement("span", {
    "data-test-id": "name",
    className: "applicant-name-data"
  }, applicantName)), /*#__PURE__*/_react.default.createElement("div", {
    className: "applicant-info-data applicant-employment-status"
  }, /*#__PURE__*/_react.default.createElement("select", Object.assign({
    id: "employment-status-select",
    className: "select-default applicant-employment-status-select"
  }, register('employmentStatusCd')), Object.values(_constants.EMPLOYMENT_STATUS).map(function (_ref2) {
    var value = _ref2.value,
      label = _ref2.label;
    return /*#__PURE__*/_react.default.createElement("option", {
      key: value,
      value: value
    }, label);
  }))), showEmploymentInfo && /*#__PURE__*/_react.default.createElement("div", {
    className: "applicant-employer-and-title"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "applicant-info-data applicant-employer"
  }, /*#__PURE__*/_react.default.createElement("input", Object.assign({
    type: "text",
    id: "applicant-employer-data",
    className: "applicant-employer-input"
  }, register('employerName', {
    validate: function validate(val) {
      return showEmploymentInfo && val !== '' || 'Employer is required';
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "tooltip"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "tooltip-text"
  }, "?"), /*#__PURE__*/_react.default.createElement("span", {
    className: "tooltip-msg"
  }, employerTooltip)), errors.employerName && /*#__PURE__*/_react.default.createElement("span", {
    className: "applicant-employer-error"
  }, errors.employerName.message)), /*#__PURE__*/_react.default.createElement("div", {
    className: "applicant-info-data applicant-job-title"
  }, /*#__PURE__*/_react.default.createElement("input", Object.assign({
    type: "text",
    id: "applicant-job-title-data",
    className: "applicant-job-title-input"
  }, register('jobTitle', {
    validate: function validate(val) {
      return showEmploymentInfo && val !== '' || 'Job title is required';
    }
  }))), errors.jobTitle && /*#__PURE__*/_react.default.createElement("span", {
    className: "applicant-job-title-error"
  }, errors.jobTitle.message))))));
};
ApplicationInformation.propTypes = {
  showEmploymentInfo: _propTypes.default.bool.isRequired,
  applicantName: _propTypes.default.string.isRequired,
  employerTooltip: _propTypes.default.string.isRequired,
  errors: _propTypes.default.shape({
    employerName: _propTypes.default.shape({
      message: _propTypes.default.string,
      type: _propTypes.default.string
    }),
    jobTitle: _propTypes.default.shape({
      message: _propTypes.default.string,
      type: _propTypes.default.string
    })
  }).isRequired,
  register: _propTypes.default.func.isRequired
};
var _default = ApplicationInformation;
exports.default = _default;
